module.exports = __webpack_public_path__ + "static/media/energy3.44d5c51d.jpg";